import React, { useEffect, useContext, useState } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { dashboardLayoutRoutes, dashboardLayoutRoutesAdmin, authLayoutRoutes, printLayoutRoutes, landingRoutes } from "./index";
import history from "./history";

import { AuthDataContext, authInstance } from '../dataStore/auth/AuthStore';

import DashboardLayout from "../layouts/Dashboard";
import Print from "../layouts/Print";
import Landing from "../layouts/Landing";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";

const childRoutes = (Layout, routes) =>
  routes.map(({ children, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component }, index) => (
        <Route
          key={index}
          path={`${path}`}
          exact
          render={props => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact
        render={props => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  );

const Routes = () => {
  const { dispatch } = useContext(AuthDataContext)
  const [dashboardRoutes, setDashboardRoutes] = useState(dashboardLayoutRoutes)
  
  useEffect(() => {
    if(localStorage.getItem('access_token') && !['auth', 'home'].includes(history.location.pathname.split('/')[1])){
      authInstance.get('/auth/user/info/')
      .then(response => {
        dispatch({type: 'processUser', data: response.data})
        if(response.data.hasProfile){
          if(!response.data.is_approved && !response.data.is_reviewed){
            history.push("/auth/account/approve/")
          }else if(!response.data.is_approved && response.data.is_reviewed){
            history.push("/auth/account/notapproved/")
          }
          if(response.data.staff){
            setDashboardRoutes(dashboardLayoutRoutesAdmin)
          }
        }else{
          history.push("/auth/sign-up/")
        }
      })
      .catch(error => {
        console.log(error)
      })
    }else if(history.location.pathname.split('/')[1] !== 'auth'){
      history.push("/home/")
    }
    
  }, [dispatch, history.location.pathname])

  return(
    <Router history={history}>
      <Switch>
        {childRoutes(DashboardLayout, dashboardRoutes)}
        {childRoutes(AuthLayout, authLayoutRoutes)}
        {childRoutes(Print, printLayoutRoutes)}
        {childRoutes(Landing, landingRoutes)}
        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
    </Router>
  );
}

export default Routes;
